import { render, staticRenderFns } from "./rp-user-create-role.vue?vue&type=template&id=72dcd78c"
import script from "./rp-user-create-role.vue?vue&type=script&lang=js"
export * from "./rp-user-create-role.vue?vue&type=script&lang=js"
import style0 from "./rp-user-create-role.vue?vue&type=style&index=0&id=72dcd78c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports